<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jr4nbv/tc-custom/9781426884405.jpg?1709154772802" alt="This image is the cover for the book Deadly Kisses, The Francesca Cahill Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deadly Kisses, The Francesca Cahill Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A Gilded Age socialite-turned-sleuth must clear her fiancé of murder in the <i>New York Times</i>–bestselling author’s historical mystery romance series.</b><br/><br/>Called to the home of her fiancé’s former mistress late one night, Francesca Cahill finds her curiosity piqued. But upon arrival, she is shocked to find Daisy Jones’s bloodied body . . . and even more devastated when the evidence points to one suspect: her fiancé, Calder Hart.<br/><br/>Francesca refuses to believe that Calder is capable of such an act. Still, she is unable to shake her instinctive sense that Calder is lying about <i>something</i>. The police are far less inclined to believe his innocence, and Calder is arrested for Daisy’s murder. But Francesca’s heart is not easily swayed—until a life-altering secret is exposed that could destroy their future together.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brenda Joyce
      </h2>
      
      <p class="authorDescription body article">Brenda Joyce is a New York Times bestselling author of more than 50 novels and novellas, including the popular and critically acclaimed de Warenne Dynasty Saga, a series of novels set in Regency and Victorian England. She lives on a ranch in Arizona with her dogs, broodmares and the year&rsquo;s current crop of foals. If she isn&rsquo;t on the back of a reining horse, she can be found madly at work in her office, penning her latest romance novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?065c0f99